import React from 'react';
import { Box, Text, VStack, Button, Flex } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import {
  getPendingNonTesseraOrders,
  getPendingSoci,
} from '../../utils/pendingNotifications';

const Notifiche = ({ userData }) => {
  const pendingSoci = getPendingSoci(userData);
  const ordersToComplete = getPendingNonTesseraOrders(userData);
  const hasPending = pendingSoci.length > 0 || ordersToComplete.length > 0;

  return (
    <Box>
      {pendingSoci.length > 0 && (
        <Box
          mb={5}
          bg="#36393f"
          border="1px solid"
          borderColor="gray.600"
          borderRadius="10px"
          p={4}
        >
          <Text color="white" fontSize="sm" fontWeight="700" mb={3}>
            Tesseramenti da completare
          </Text>
          <VStack spacing={2} align="stretch">
            {pendingSoci.map((socio) => {
              const socioName =
                [socio.nomeSocio, socio.cognomeSocio]
                  .filter(Boolean)
                  .join(' ') || 'Socio';
              const socioId = socio.documentId || socio.id;

              return (
                <Flex
                  key={`socio-${socioId}`}
                  align={{ base: 'stretch', md: 'center' }}
                  justify="space-between"
                  gap={3}
                  p={3}
                  bg="#2f3136"
                  border="1px solid"
                  borderColor="gray.600"
                  borderRadius="8px"
                  flexDirection={{ base: 'column', md: 'row' }}
                >
                  <Text
                    color="gray.100"
                    fontSize="sm"
                    fontWeight="600"
                    flex="1"
                  >
                    Tesseramento — {socioName}
                  </Text>
                  <Text
                    color="#ffcc00"
                    fontSize="sm"
                    fontWeight="700"
                    minW={{ md: '90px' }}
                  >
                    In attesa di pagamento
                  </Text>
                  <Button
                    as={RouterLink}
                    to={`/account/tesseramenti?id=${socioId}`}
                    size="sm"
                    bg="#ffcc00"
                    color="black"
                    fontWeight="600"
                    borderRadius="8px"
                    px={4}
                    _hover={{ bg: '#ffdd44' }}
                    _active={{ bg: '#e6b800' }}
                  >
                    Paga ora
                  </Button>
                </Flex>
              );
            })}
          </VStack>
        </Box>
      )}

      {ordersToComplete.length > 0 && (
        <Box
          mb={5}
          bg="#36393f"
          border="1px solid"
          borderColor="gray.600"
          borderRadius="10px"
          p={4}
        >
          {pendingSoci.length > 0 && (
            <Text color="white" fontSize="sm" fontWeight="700" mb={3}>
              Ordini da completare
            </Text>
          )}
          <VStack spacing={2} align="stretch">
            {ordersToComplete.map((order) => {
              let orderName = 'Ordine';
              if (
                order.product &&
                (order.product.nome || order.product.attributes?.nome)
              ) {
                orderName =
                  order.product.nome || order.product.attributes?.nome;
              } else if (order.event && order.event.Nome) {
                orderName = order.event.Nome;
              }
              const duePrice = Number(order.price || 0).toFixed(2);
              const orderDate = order.createdAt
                ? new Date(order.createdAt).toLocaleDateString('it-IT')
                : '-';
              const orderId = order.documentId || order.id;

              return (
                <Flex
                  key={`order-${order.id || order.event?.id || order.product?.id || order.event?.Nome || order.product?.nome}`}
                  align={{ base: 'stretch', md: 'center' }}
                  justify="space-between"
                  gap={3}
                  p={3}
                  bg="#2f3136"
                  border="1px solid"
                  borderColor="gray.600"
                  borderRadius="8px"
                  flexDirection={{ base: 'column', md: 'row' }}
                >
                  <Text
                    color="gray.100"
                    fontSize="sm"
                    fontWeight="600"
                    flex="1"
                  >
                    {orderName}
                  </Text>
                  <Text color="gray.300" fontSize="sm" minW={{ md: '110px' }}>
                    {orderDate}
                  </Text>
                  <Text
                    color="#ffcc00"
                    fontSize="sm"
                    fontWeight="700"
                    minW={{ md: '90px' }}
                  >
                    EUR {duePrice}
                  </Text>
                  <Button
                    as={RouterLink}
                    to={`/account/ordini?focusOrder=${orderId}`}
                    size="sm"
                    bg="#ffcc00"
                    color="black"
                    fontWeight="600"
                    borderRadius="8px"
                    px={4}
                    _hover={{ bg: '#ffdd44' }}
                    _active={{ bg: '#e6b800' }}
                  >
                    Vai
                  </Button>
                </Flex>
              );
            })}
          </VStack>
        </Box>
      )}

      {!hasPending && (
        <Box
          textAlign="center"
          py={10}
          bg="#36393f"
          border="1px solid"
          borderColor="gray.600"
          borderRadius="10px"
        >
          <FaCheckCircle
            size={40}
            color="#68d391"
            style={{ margin: '0 auto 12px auto' }}
          />
          <Text color="white" fontSize="md" fontWeight="600" mb={2}>
            Nessuna notifica pendente
          </Text>
          <Text color="gray.300" fontSize="sm">
            Non hai tesseramenti o ordini da completare.
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default Notifiche;
